import { Box } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../AppContext';
import { Actions } from '../../enums/ActionEnums';
import { Types } from '../../enums/TypeEnums';
import {
  IIndexSerie,
  IIndexSeriesQuery,
  IndexSeriesDocument,
  useDeleteIndexSerieMutation,
  useIndexSeriesQuery
} from '../../generated/graphql';
import { canUserCreate } from '../../utils/rightUtils';
import { FormatTableData } from '../../utils/styleUtils';
import OverviewTable, { IHeadCell } from '../Common/Tables/OverviewTable';
import IndexSerieForm from './IndexSerieForm';

const IndexSerieList: React.FunctionComponent = () => {
  const { dispatch, state } = useContext(AppContext);
  const { data, loading } = useIndexSeriesQuery();
  const [allData, setAllData] = useState<IIndexSerie[]>([]);
  const [deleteIndexSerie] = useDeleteIndexSerieMutation();
  const [openCreateIndexSerie, setOpenCreateIndexSerie] = useState(false);
  const [indexSerie, setIndexSerie] = useState<IIndexSerie | null>(null);
  const canCreate = canUserCreate(state.user, Types.IndexSeries);

  useEffect(() => {
    if (data && data.result) {
      setAllData(data.result as IIndexSerie[]);
    }
  }, [data]);

  const handleRemove = (rowData: IIndexSerie) => {
    dispatch({
      type: Actions.ShowConfirmation,
      payload: {
        text: `Are you sure you want to delete ${rowData.name} index serie?`,
        agreeAction: handleDelete,
        params: rowData
      }
    });
  };

  const handleClose = (saved: boolean, isNew?: boolean, indexSerieInput?: IIndexSerie) => {
    if (saved && indexSerieInput) {
      if (isNew) {
        addIndexSerie(indexSerieInput);
      }
    }
    setIndexSerie(null);
    setOpenCreateIndexSerie(false);
  };

  const addIndexSerie = (input: IIndexSerie) => {
    const existing = allData.find((d) => d.id === input.id);
    if (!existing) {
      setAllData([input, ...allData]);
    }
  };

  const handleDetails = (rowData: IIndexSerie) => {
    setIndexSerie(rowData);
    setOpenCreateIndexSerie(true);
  };

  const handleDelete = (rowData: IIndexSerie) => {
    dispatch({
      type: Actions.HideConfirmation
    });
    deleteIndexSerie({
      variables: {
        id: rowData.id
      },
      update(cache) {
        const indexSeriesListQuery = cache.readQuery({
          query: IndexSeriesDocument
        }) as IIndexSeriesQuery;
        if (indexSeriesListQuery.result) {
          const cachedIndex = indexSeriesListQuery.result.findIndex((is) => is?.id === rowData.id);
          if (cachedIndex > -1) {
            const data = indexSeriesListQuery.result.filter((is) => is?.id !== rowData.id);
            cache.writeQuery({
              query: IndexSeriesDocument,
              data: { result: data }
            });
          }
        }
      }
    }).catch((e) => {
      dispatch({
        type: Actions.ShowMessage,
        payload: { text: e.message, severity: 'error' }
      });
    });
    dispatch({
      type: Actions.ShowMessage,
      payload: {
        text: `${rowData.name} index deleted`,
        severity: 'success'
      }
    });
  };
  const columns = [
    {
      title: 'Details',
      width: 64,
      sorting: false
    },
    {
      title: 'Index Serie Name',
      field: 'name',
      width: 1565
    },
    {
      title: 'Remove',
      width: 71,
      sorting: false
    }
  ] as IHeadCell[];
  return (
    <Box className="overviewPage">
      <OverviewTable
        columns={columns}
        data={FormatTableData(allData)}
        loading={loading}
        handleDetails={handleDetails}
        handleRemove={handleRemove}
        pageSize={15}
        createButtonProps={{
          id: 'create-index-serie-button',
          onClick: () => setOpenCreateIndexSerie(true),
          text: 'Create Serie',
          disabled: !canCreate
        }}
      />
      {openCreateIndexSerie && (
        <IndexSerieForm handleClose={handleClose} indexSerieInput={indexSerie} />
      )}
    </Box>
  );
};
export default IndexSerieList;
